const $$splitComponentImporter = () => import('/src/src/routes/enrollment/complete.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/enrollment/complete")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    referrer: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Activated",
      description: "Page title for the enrollment finalization page"
    })
  }
});